import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const BRANDS = [
  "MICHELIN", "PIRELLI", "BRIDGESTONE", "CONTINENTAL", "GOODYEAR",
  "FALKEN", "YOKOHAMA", "HANKOOK", "DUNLOP", "TOYO",
];

export const BrandMarquee = () => {
  const [logos, setLogos] = useState({});

  useEffect(() => {
    api.get("/brands").then((r) => {
      const map = {};
      r.data.forEach((b) => { if (b.logo) map[b.name.toUpperCase()] = b.logo; });
      setLogos(map);
    }).catch(() => {});
  }, []);

  const row = [...BRANDS, ...BRANDS];
  return (
    <div className="py-8 border-y border-border bg-background overflow-hidden marquee-mask relative z-10" data-testid="brand-marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((b, i) => (
          <div key={i} className="flex items-center gap-8 px-8">
            {logos[b] ? (
              <img src={logos[b]} alt={b} className="h-10 sm:h-12 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity" loading="lazy" />
            ) : (
              <span className="font-display font-black text-3xl sm:text-5xl uppercase tracking-tight text-foreground/25 hover:text-primary transition-colors">
                {b}
              </span>
            )}
            <span className="w-2 h-2 rounded-full bg-primary/60" />
          </div>
        ))}
      </div>
    </div>
  );
};
